import { SourceComponents } from '@updater/informant-core';
import { PhoneNumberInput } from '@updater/ui-uds';

export const PhoneNumberField: SourceComponents['PhoneNumberField'] = (
  props
) => {
  return <PhoneNumberInput {...props} />;
};
